import React, { useState } from 'react';
import PDFViewerV2 from "./PDFViewerV2";
const TestingComponent = () => {
    
    return (
        <div className="full-screen-frame">
            <PDFViewerV2  />
        </div>
    );
};

export default TestingComponent;